import { ccv2Fetch } from './index';

/** @returns {Promise<Array>} */
export const fetchAgents = () => ccv2Fetch('/v2/callcenter/agents');

/** @param {string} agentKey @returns {Promise<Object>} */
export const fetchAgent = (agentKey) => ccv2Fetch(`/v2/callcenter/agents/${encodeURIComponent(agentKey)}`);

/** @param {Object} dto @returns {Promise<Object>} */
export const createAgent = (dto) =>
  ccv2Fetch('/v2/callcenter/agents', { method: 'POST', body: JSON.stringify(dto) });

/** @param {string} agentKey @param {Object} dto @returns {Promise<Object>} */
export const updateAgent = (agentKey, dto) =>
  ccv2Fetch(`/v2/callcenter/agents/${encodeURIComponent(agentKey)}`, {
    method: 'PUT',
    body: JSON.stringify(dto),
  });

/** @param {string} agentKey @returns {Promise<null>} */
export const deleteAgent = (agentKey) =>
  ccv2Fetch(`/v2/callcenter/agents/${encodeURIComponent(agentKey)}`, { method: 'DELETE' });

/** @param {string} agentKey @param {{ pauseReasonId: number, notes?: string }} dto */
export const pauseAgent = (agentKey, dto) =>
  ccv2Fetch(`/v2/callcenter/agents/${encodeURIComponent(agentKey)}/pause-v2`, {
    method: 'POST',
    body: JSON.stringify(dto),
  });

/** @param {string} agentKey @param {{ notes?: string }} dto */
export const unpauseAgent = (agentKey, dto = {}) =>
  ccv2Fetch(`/v2/callcenter/agents/${encodeURIComponent(agentKey)}/unpause-v2`, {
    method: 'POST',
    body: JSON.stringify(dto),
  });

/** @param {string} agentKey @param {{ workScheduleId: number }} dto */
export const assignWorkSchedule = (agentKey, dto) =>
  ccv2Fetch(`/v2/callcenter/agents/${encodeURIComponent(agentKey)}/work-schedule`, {
    method: 'PUT',
    body: JSON.stringify(dto),
  });

/** @param {string} agentKey @returns {Promise<Object>} */
export const getScheduleState = (agentKey) =>
  ccv2Fetch(`/v2/callcenter/agents/${encodeURIComponent(agentKey)}/schedule-state`);

/** @param {string} agentKey @param {{ durationMinutes?: number, reason?: string }} dto */
export const forceEnableAgent = (agentKey, dto = {}) =>
  ccv2Fetch(`/v2/callcenter/agents/${encodeURIComponent(agentKey)}/force-enable`, {
    method: 'POST',
    body: JSON.stringify(dto),
  });

/** @param {string} agentKey @param {{ durationMinutes?: number, reason?: string }} dto */
export const forceDisableAgent = (agentKey, dto = {}) =>
  ccv2Fetch(`/v2/callcenter/agents/${encodeURIComponent(agentKey)}/force-disable`, {
    method: 'POST',
    body: JSON.stringify(dto),
  });

/** @param {string} agentKey */
export const clearForceAgent = (agentKey) =>
  ccv2Fetch(`/v2/callcenter/agents/${encodeURIComponent(agentKey)}/clear-force`, {
    method: 'POST',
    body: JSON.stringify({}),
  });
